module.exports = __webpack_public_path__ + "static/media/image-3.f7a633f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/SEOin2020/image-3.png
// module id = 465
// module chunks = 0